<template>
  <button
    @click="buttonClicked"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'FormButton',

  props: {
    styleType: {
      type: String,
      required: false,
      default: 'primary-filled'
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: {
    click: null
  },

  methods: {
    buttonClicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>
